/**
 * THIS SHAPE IS FOR INITIAL SET-UP TASKS: 
 *    + CHOOSE THE CLOSEST ELEVATOR/ESCALATOR
 *    + SELECT THE FLOOR WHERE THE DEVICE IS LOCATED
 *    + SELECT THE  POSITION OF THE DEVICE
 */

import React from 'react';
// import vertices from './vertices.json';
// import connections from './connections.json';
import { ReactComponent as MapF0 } from 'assets/images/map_f0.svg';
import { ReactComponent as MapF1 } from 'assets/images/map_f1_2026_05.svg';
import { ReactComponent as MapF2 } from 'assets/images/map_f2_2026_05.svg';
import { ReactComponent as MapF3 } from 'assets/images/map_f3_2026_05.svg';
import pin from 'assets/images/pin.svg'

import styles from './styles.module.css';
import { arrayOf, number, shape, array, func } from 'prop-types';
import distanceCalculator from 'utils/distanceCalculator';
import connectIDGen from 'utils/connectIDGen';
import searchPath from 'utils/searchPath';
import matrixBuilder, { allNodesInfo } from 'utils/matrixBuilder';
import LocationPin from 'components/LocationPin';
import DynamicIcon from 'components/DynamicIcon';
import iconPin from 'assets/images/icon_pin.svg';
import { pinSize } from 'config/sizes';

MapShape.propTypes = {
  floorIndex: number,
  rotate: number,
  onSelect: func,
  pinsList: arrayOf(
    shape({
      x: number,
      y: number
    })
  )
};

MapShape.defaultProps = {
  floorIndex: 0,
}

function MapShape(props) {
  const { floorIndex, rotate } = props;

  const modelSvg = React.useRef();
  const svgContainer = React.useRef();
  const [svgOffetTop, setSvgOffetTop] = React.useState(0);
  const [didMount, setDidMount] = React.useState(false);
  const [orientation, setOrientation] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [viewBox, setViewBox] = React.useState({
    width: 0,
    widthHeightRatio: 0
  });

  const [path, setPath] = React.useState([]);

  const switchMapSvg = React.useCallback(() => {
    switch (floorIndex) {
      case 0:
        return <MapF0 ref={modelSvg} />
      case 1:
        return <MapF1 ref={modelSvg} />
      case 2:
        return <MapF2 ref={modelSvg} />
      case 3:
        return <MapF3 ref={modelSvg} />
    }
  }, [floorIndex]);

  React.useEffect(() => {
    if (modelSvg.current) {
      const mainSvg = modelSvg.current;
      const viewBoxReference = mainSvg?.attributes?.viewBox?.nodeValue.split(' ');

      const width = viewBoxReference[2];
      const widthHeightRatio = viewBoxReference[2] / viewBoxReference[3];
      setViewBox({ width, widthHeightRatio });
    }

    if (svgContainer.current) {
      const container = svgContainer.current;
      const { width, height } = container.getClientRects()[0];
      setSvgOffetTop((width - height) / 2);
    }

  }, [floorIndex]);

  const svgViewBox = React.useRef('');
  const svgWidthHeight = React.useRef({
    width: 0,
    height: 0
  });

  React.useEffect(() => {
    if (svgContainer.current) {
      const container = svgContainer.current;
      const targetSVG = container.querySelector('svg');
      svgViewBox.current = targetSVG.getAttribute('viewBox');
      const { width, height } = container.getClientRects()[0];
      svgWidthHeight.current = { width, height }
    }
    setDidMount(true);
  }, ['didMount']);

  React.useEffect(() => {
    const { width, height } = svgWidthHeight.current;
    setSvgOffetTop((width - height) / 2);
    setOrientation(rotate);
  }, [didMount]);

  React.useEffect(() => {
    setOrientation(rotate);
  }, [rotate]);

  return (
    <div className={styles.main_div} style={orientation === 90 || orientation === 270 ? { height: `${svgWidthHeight.current.width}px` } : {}}>
      {loading ?
        (
          <div className="loading">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <p>
              Dang loading nhe'
            </p>
          </div>
        ) :
        (<div className={`${styles.svg_container} rotate_${orientation}`} ref={svgContainer} style={orientation === 90 || orientation === 270 ? { position: 'relative', top: `${svgOffetTop}px` } : {}}>
          {switchMapSvg()}
          <svg
            className={styles.svg_path}
            viewBox={svgViewBox.current || undefined}
          >
            {
              props.pinsList?.map((item, index) => {
                return (
                  <DynamicIcon
                    logoRectSize={pinSize}
                    key={item.id !== undefined ? item.id : index}
                    id={item.id}
                    floorLevel={floorIndex}
                    href={iconPin}
                    x={item.x}
                    y={item.y}
                    onClick={() => props.onSelect(item.id)}
                  />
                );
              })
            }
          </svg>
        </div>)
      }

    </div>
  );
}

export default MapShape;

MapShape.defaultProps = {
  rotate: 0
}